<template>
    <div>
        <div :class="[ expandable ? 'panel--expand' : 'panel' ]">
            <div class="panel__header">
                <h2>
                    <i class="panel__header__icon icons icon-graduation"></i>
                    <span>{{$t('dashboard.languages.title')}}</span>
                </h2>
            </div>

            <div class="panel__body" :class="{expanded}">
                <div v-if="!languages.length" class="panel--empty">
                    <center>{{$t('dashboard.languages.no_languages')}}</center>
                </div>
                <div v-else>
                    <table class="table">
                        <thead>
                            <tr>
                                <th>{{$t('dashboard.languages.table.talen')}}</th>
                                <th>{{$t('dashboard.languages.table.spreken')}}</th>
                                <th>{{$t('dashboard.languages.table.lezen')}}</th>
                                <th>{{$t('dashboard.languages.table.schrijven')}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(language, index) in languages" :key="`l_${index}`">
                                <td>{{language.name}}</td>
                                <td>{{language.speak}}/10</td>
                                <td>{{language.read}}/10</td>
                                <td>{{language.write}}/10</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div v-if="expandable" class="panel__btn-expand" @click="togglePanelExpansion">
                <div v-if="expanded"><i class="icons icon-arrow-up"></i>{{$t('dashboard.languages.see_less')}}</div>
                <div v-else><i class="icons icon-arrow-down"></i>{{$t('dashboard.languages.see_all')}}</div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import { Component, Prop } from 'vue-property-decorator';

    @Component({})
    export default class LanguagesPanel extends Vue {
        name = 'languages-panel';
        expanded = false;

        get languages() {
            return this.$store.state.profile.profile.languages || [];
        }

        togglePanelExpansion() {
            this.expanded = !this.expanded;
        }

        get expandable() {
            return this.languages.length && this.languages.length > 2;
        }
    }

</script>



// WEBPACK FOOTER //
// src/components/panels/profile/LanguagesPanel.vue